/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomeresponsepartial2Inputs */

const en_outcomeresponsepartial2 = /** @type {(inputs: Outcomeresponsepartial2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replied but vague / non-committal`)
};

const pt_outcomeresponsepartial2 = /** @type {(inputs: Outcomeresponsepartial2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respondeu mas de forma vaga`)
};

/**
* | output |
* | --- |
* | "Replied but vague / non-committal" |
*
* @param {Outcomeresponsepartial2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeresponsepartial2 = /** @type {((inputs?: Outcomeresponsepartial2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeresponsepartial2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeresponsepartial2(inputs)
	return pt_outcomeresponsepartial2(inputs)
});
export { outcomeresponsepartial2 as "outcomeResponsePartial" }